import styled from "@emotion/styled";
import DisplayType from "utils/displayType";
import { useLayoutEffect } from "react";
import { updateTitle } from "utils/commonUtil";
import { useLanguage } from "i18n/LanguageContext";
import { renderText } from "i18n/TranslatedText";
import Footer from "../../component/footer/Footer";
import { ReactComponent as Logo } from "../../assets/logo_blue_labs.svg";
import { ReactComponent as Email } from "../../assets/email__icon.svg";
import { ReactComponent as Agenda } from "../../assets/bluelabs_agenda.svg";
import { ReactComponent as Excavation } from "../../assets/bluelabs_excavation.svg";
import { ReactComponent as Growth } from "../../assets/bluelabs_growth.svg";
import { ReactComponent as GrayDot } from "../../assets/bluelabs_gray_dot.svg";
import logoDifferentDoors from "../../assets/logo_different_doors.png";

const BlueLabs = () => {
  const mode = DisplayType();
  const { t } = useLanguage();

  useLayoutEffect(() => {
    updateTitle(t("program", "blueLabs.pageTitle"));
  }, [t]);

  return (
    <Container>
      <HeaderContainer>
        <Logo className="program__logo" />
        <span
          className={`program__title ${
            mode === "Mobile" ? "font-bold-24" : "font-title"
          }`}
        >
          {t("program", "blueLabs.title")}
        </span>
        <p
          className={`program__description ${
            mode === "Mobile" ? "font-body3" : "font-body2"
          }`}
        >
          {renderText(t("program", "blueLabs.desc"), mode)}
        </p>
      </HeaderContainer>
      <BodyContainer className="limit__body">
        <ProgramDescription>
          <div
            className={`program__description__title ${
              mode === "Mobile" ? "font-sub-title2" : "font-title"
            }`}
            style={{
              marginTop: `${mode === "Mobile" ? "40px" : "100px"}`,
            }}
          >
            {t("program", "blueLabs.descTitle1")}
          </div>
          <p
            className={`${mode === "Mobile" ? "font-body3" : "font-body2"}`}
            style={{ wordBreak: "keep-all" }}
          >
            {renderText(t("program", "blueLabs.descBody1a"), mode)}
          </p>
          <div
            className={`program__description__title ${
              mode === "Mobile" ? "font-sub-title2" : "font-title"
            }`}
            style={{
              marginTop: "60px",
            }}
          >
            {t("program", "blueLabs.descTitle2")}
          </div>
          <p
            className={`${mode === "Mobile" ? "font-body3" : "font-body2"}`}
            style={{ wordBreak: "keep-all" }}
          >
            {renderText(t("program", "blueLabs.descBody2a"), mode)}
          </p>
        </ProgramDescription>
        <ProgramSolution
          style={{
            marginTop: "140px",
            padding: `${mode === "Mobile" ? "40px 10px" : "76px"}`,
          }}
        >
          <span
            className={`${
              mode === "Mobile" ? "font-bold-16" : "font-bold-20"
            } program__solution__title`}
            style={{
              marginBottom: `${mode === "Mobile" ? "28px" : "50px"}`,
            }}
          >
            {renderText(t("program", "blueLabs.solutionTitle"), mode)}
          </span>
          <div
            className={`${
              mode === "Mobile"
                ? "program__solution__column"
                : "program__solution__row"
            }`}
            style={{
              gap: `${mode === "Mobile" && "30px"}`,
            }}
          >
            <div
              className={`program__solution__content ${
                mode === "Mobile"
                  ? "program__solution__row"
                  : "program__solution__column"
              }`}
              style={{
                textAlign: `${mode === "Mobile" ? "start" : "center"}`,
                justifyContent: `${
                  mode === "Mobile" ? "center" : "flex-start"
                }`,
              }}
            >
              <div
                className="svg-container"
                style={{
                  width: `${mode === "Mobile" ? "72px" : "136px"}`,
                  height: `${mode === "Mobile" ? "72px" : "136px"}`,
                }}
              >
                <Agenda
                  style={{
                    width: `${mode === "Mobile" && "67px"}`,
                    // height: `${mode === "Mobile" && "73px"}`,
                  }}
                />
              </div>
              <span
                className={`${
                  mode === "Mobile" ? "font-regular-14" : "font-regular-16"
                }`}
              >
                {renderText(t("program", "blueLabs.solutionAgenda"), mode)}
              </span>
            </div>
            <div
              className={`program__solution__content ${
                mode === "Mobile"
                  ? "program__solution__row"
                  : "program__solution__column"
              }`}
              style={{
                textAlign: `${mode === "Mobile" ? "start" : "center"}`,
                justifyContent: `${
                  mode === "Mobile" ? "center" : "flex-start"
                }`,
              }}
            >
              <div
                className="svg-container"
                style={{
                  width: `${mode === "Mobile" ? "72px" : "136px"}`,
                  height: `${mode === "Mobile" ? "72px" : "136px"}`,
                }}
              >
                <Excavation
                  style={{
                    width: `${mode === "Mobile" && "72px"}`,
                    // height: `${mode === "Mobile" && "73px"}`,
                  }}
                />
              </div>
              <span
                className={`${
                  mode === "Mobile" ? "font-regular-14" : "font-regular-16"
                }`}
              >
                {renderText(t("program", "blueLabs.solutionExcavation"), mode)}
              </span>
            </div>
            <div
              className={`program__solution__content ${
                mode === "Mobile"
                  ? "program__solution__row"
                  : "program__solution__column"
              }`}
              style={{
                textAlign: `${mode === "Mobile" ? "start" : "center"}`,
                justifyContent: `${
                  mode === "Mobile" ? "center" : "flex-start"
                }`,
              }}
            >
              <div
                className="svg-container"
                style={{
                  width: `${mode === "Mobile" ? "72px" : "136px"}`,
                  height: `${mode === "Mobile" ? "72px" : "136px"}`,
                }}
              >
                <Growth
                  style={{
                    width: `${mode === "Mobile" && "51px"}`,
                    // height: `${mode === "Mobile" && "73px"}`,
                  }}
                />
              </div>
              <span
                className={`${
                  mode === "Mobile" ? "font-regular-14" : "font-regular-16"
                }`}
              >
                {renderText(t("program", "blueLabs.solutionGrowth"), mode)}
              </span>
            </div>
          </div>
        </ProgramSolution>
        <ProgramProcess
          style={{ marginTop: `${mode === "Mobile" ? "100px" : "140px"}` }}
        >
          <div
            className={`program__process__title ${
              mode === "Mobile" ? "font-bold-22" : "font-sub-title"
            }`}
          >
            {t("program", "blueLabs.processTitle")}
          </div>
          <div className={`program__process__row`}>
            <span
              className={`${
                mode === "Mobile" ? "font-bold-16" : "font-bold-18"
              }`}
            >
              {t("program", "blueLabs.targetLabel")}
            </span>
            <span
              className={`${mode === "Mobile" ? "font-body3" : "font-body2"}`}
            >
              {t("program", "blueLabs.targetValue")}
            </span>
          </div>

          <div className="program__process__list">
            <ProgramProcessItem>
              <div className={`program__process__item__column flex-2`}>
                <span
                  className={`${
                    mode === "Mobile" ? "font-bold-20" : "font-bold-28"
                  }`}
                  style={{
                    color: "var(--primary)",
                    textTransform: "uppercase",
                  }}
                >
                  Step. 1
                </span>
              </div>
              <div className="program__process__item__column  flex-4">
                <span
                  className={`program__process__item__title ${
                    mode === "Mobile" ? "font-body3" : "font-body2"
                  }`}
                  style={{
                    color: "var(--primary)",
                    marginBottom: `${mode === "Mobile" ? "8px" : "4px"}`,
                  }}
                >
                  {t("program", "blueLabs.step1Title")}
                </span>
                <span
                  className={`item__descrition ${
                    mode === "Mobile" ? "font-body3" : "font-body2"
                  }`}
                >
                  {t("program", "blueLabs.step1Desc")}
                </span>
              </div>
            </ProgramProcessItem>
            <ProgramProcessItem>
              <div className={`program__process__item__column flex-2`}>
                <span
                  className={`${
                    mode === "Mobile" ? "font-bold-20" : "font-bold-28"
                  }`}
                  style={{
                    color: "var(--primary)",
                    textTransform: "uppercase",
                  }}
                >
                  Step. 2
                </span>
              </div>
              <div className="program__process__item__column  flex-4">
                <span
                  className={`program__process__item__title ${
                    mode === "Mobile" ? "font-body3" : "font-body2"
                  }`}
                  style={{
                    color: "var(--primary)",
                    marginBottom: `${mode === "Mobile" ? "8px" : "4px"}`,
                  }}
                >
                  {t("program", "blueLabs.step2Title")}
                </span>
                <span
                  className={`item__descrition ${
                    mode === "Mobile" ? "font-body3" : "font-body2"
                  }`}
                >
                  {t("program", "blueLabs.step2Desc")}
                </span>
              </div>
            </ProgramProcessItem>
            <ProgramProcessItem>
              <div className={`program__process__item__column flex-2`}>
                <span
                  className={`${
                    mode === "Mobile" ? "font-bold-20" : "font-bold-28"
                  }`}
                  style={{
                    color: "var(--primary)",
                    textTransform: "uppercase",
                  }}
                >
                  Step. 3
                </span>
              </div>
              <div className="program__process__item__column  flex-4">
                <span
                  className={`program__process__item__title ${
                    mode === "Mobile" ? "font-body3" : "font-body2"
                  }`}
                  style={{
                    color: "var(--primary)",
                    marginBottom: `${mode === "Mobile" ? "8px" : "4px"}`,
                  }}
                >
                  {t("program", "blueLabs.step3Title")}
                </span>
                <span
                  className={`item__descrition ${
                    mode === "Mobile" ? "font-body3" : "font-body2"
                  }`}
                >
                  {t("program", "blueLabs.step3Desc")}
                </span>
              </div>
            </ProgramProcessItem>
            <ProgramProcessItem>
              <div className={`program__process__item__column flex-2`}>
                <span
                  className={`${
                    mode === "Mobile" ? "font-bold-20" : "font-bold-28"
                  }`}
                  style={{
                    color: "var(--primary)",
                    textTransform: "uppercase",
                  }}
                >
                  Step. 4
                </span>
              </div>
              <div className="program__process__item__column  flex-4">
                <span
                  className={`program__process__item__title ${
                    mode === "Mobile" ? "font-body3" : "font-body2"
                  }`}
                  style={{
                    color: "var(--primary)",
                    marginBottom: `${mode === "Mobile" ? "8px" : "4px"}`,
                  }}
                >
                  {t("program", "blueLabs.step4Title")}
                </span>
                <span
                  className={`item__descrition ${
                    mode === "Mobile" ? "font-body3" : "font-body2"
                  }`}
                >
                  {t("program", "blueLabs.step4Desc")}
                </span>
              </div>
            </ProgramProcessItem>
          </div>
        </ProgramProcess>
        <ProgramProject
          style={{ marginTop: `${mode === "Mobile" ? "100px" : "140px"}` }}
        >
          <div
            className={`program__project__title ${
              mode === "Mobile" ? "font-bold-22" : "font-sub-title"
            }`}
          >
            {t("program", "blueLabs.projectTitle")}
          </div>
          <div
            className={`${
              mode === "Mobile"
                ? "program__project__column"
                : "program__project__row"
            }`}
            style={{
              gap: `${mode === "Mobile" ? "16px" : "40px"}`,
              alignItems: `${mode === "Mobile" && "center"}`,
            }}
          >
            <div
              className="logo-container"
              style={{
                width: `${mode === "Mobile" ? "335px" : "360px"}`,
                height: `${mode === "Mobile" ? "160px" : "180px"}`,
              }}
            >
              <div
                style={{
                  backgroundImage: `url(${logoDifferentDoors})`,
                  width: `${mode === "Mobile" ? "168px" : "176px"}`,
                  height: `${mode === "Mobile" ? "97px" : "101px"}`,
                }}
              />
            </div>
            <div className="program__project__contents">
              <div
                className={`company-name ${
                  mode === "Mobile" ? "font-bold-20" : "font-bold-24"
                }`}
              >
                {t("program", "blueLabs.projectName")}
              </div>
              <div
                className={`company-item ${
                  mode === "Mobile" ? "font-regular-16" : "font-regular-18"
                }`}
                style={{
                  marginBottom: `${mode === "Mobile" ? "8px" : "16px"}`,
                }}
              >
                {t("program", "blueLabs.projectItem")}
              </div>
              <span
                className={`company-description ${
                  mode === "Mobile" ? "font-regular-16" : "font-regular-18"
                }`}
              >
                {renderText(t("program", "blueLabs.projectDesc"), mode)}
              </span>
            </div>
          </div>
        </ProgramProject>
        <ProgramProcess
          style={{ marginTop: `${mode === "Mobile" ? "100px" : "120px"}` }}
        >
          <div
            className={`program__process__title ${
              mode === "Mobile" ? "font-bold-22" : "font-sub-title"
            }`}
          >
            {t("program", "blueLabs.contactTitle")}
          </div>
          <a
            href="mailto:bluelabs@bluepoint.ac"
            style={{ textDecoration: "none" }}
          >
            <EmailContainer>
              <Email className="email__icon" />
              <span
                className={`email__text ${
                  mode === "Mobile" ? "font-regular-16" : "font-regulra-22"
                }`}
              >
                bluelabs@bluepoint.ac
              </span>
            </EmailContainer>
          </a>
        </ProgramProcess>
      </BodyContainer>
      <Footer />
    </Container>
  );
};
const Container = styled.div`
  width: 100%;
  height: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  padding-top: 80px;

  @media only screen and (max-width: 768px) {
    padding-top: 60px;
  }
`;

const HeaderContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: var(--bg-02);
  padding-top: 80px;
  padding-bottom: 80px;

  .program__logo {
    width: 240px;
    min-width: 240px;
    max-width: 240px;
    height: 240px;
    min-width: 240px;
    max-width: 240px;
  }
  .program__title {
    color: var(--black);
    margin-top: 24px;
    margin-bottom: 16px;
  }
  .program__description {
    color: var(--grey-40);
    text-align: center;
  }

  @media only screen and (max-width: 768px) {
    padding-bottom: 60px;
    .program__logo {
      width: 117px;
      min-width: 117px;
      max-width: 117px;
      height: 117px;
      min-width: 117px;
      max-width: 117px;
    }
    .program__title {
      color: var(--black);
      margin-top: 24px;
      margin-bottom: 8px;
    }
  }
`;

const BodyContainer = styled.div`
  width: 100%;
  flex-grow: 1;
  display: flex;
  flex-direction: column;

  margin-bottom: 160px;

  span {
    word-break: keep-all;
  }
`;

const ProgramDescription = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  .program__description__title {
    color: var(--primary);
    margin-bottom: 24px;
  }

  @media only screen and (max-width: 768px) {
    margin-top: 40px;
    .program__description__title {
      margin-bottom: 16px;
    }
  }
`;

const ProgramSolution = styled.div`
  height: fit-content;
  border: 1px solid #e5e5ea;
  display: flex;
  flex-direction: column;
  align-items: center;

  .program__solution__title {
    color: #7e91fe;
    text-align: center;
  }

  .program__solution__row {
    width: 100%;
    display: flex;
    flex-direction: row;
  }

  .program__solution__column {
    width: 100%;
    display: flex;
    flex-direction: column;
  }
  .program__solution__content {
    /* justify-content: flex-start; */
    align-items: center;
    flex: 1;
    color: #636366;

    .svg-container {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  @media only screen and (max-width: 768px) {
    .program__solution__content {
      span {
        min-width: 156px;
        margin-left: 20px;
      }
    }
  }
`;

const ProgramProcess = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  margin-top: 100px;

  .program__process__title {
    color: var(--black);
    margin-bottom: 24px;
  }

  .program__process__row {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 16px;
  }

  .program__process__list {
    width: 100%;
    border-top: 1px solid var(--grey-00);
    display: flex;
    flex-direction: column;
    margin-top: 24px;
  }
  @media only screen and (max-width: 768px) {
    margin-top: 40px;
    .program__process__title {
      margin-bottom: 16px;
    }
    .program__process__row {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 4px;
    }
  }
`;

const ProgramProcessItem = styled.div`
  width: 100%;
  padding: 32px;
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid var(--grey-00);
  .flex-2 {
    flex: 2;
  }
  .flex-4 {
    flex: 4;
  }
  .program__process__item__column {
    display: flex;
    flex-direction: column;
    min-width: 100px;
    justify-content: flex-start;
  }

  .program__process__item__row {
    display: flex;
    flex-direction: row;
    align-items: center;
    .program__process__item__title {
      width: 35px;
    }
  }
  .item__title {
    color: var(--primary);
  }
  .item__descrition {
    color: var(--grey-60);
  }
  @media only screen and (max-width: 768px) {
    flex-direction: column;
    gap: 8px;
    padding: 24px 16px;

    .program__process__item__row {
      .program__process__item__title {
        width: 24px;
      }
    }
  }
`;

const ProgramProject = styled.div`
  width: 100%;
  .program__project__title {
    margin-bottom: 20px;
  }

  .program__project__row {
    width: 100%;
    display: flex;
    flex-direction: row;
  }

  .program__project__column {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .logo-container {
    border: 1px solid #e5e5ea;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .program__project__contents {
    display: flex;
    flex-direction: column;
    flex: 1;
    .company-name {
      margin-bottom: 4px;
    }
    .company-item {
      color: #636366;
    }
    .company-description {
    }
  }

  @media only screen and (max-width: 768px) {
    .program__project__contents {
      align-items: center;
      text-align: center;
    }
  }
`;

const EmailContainer = styled.div`
  margin-top: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  .email__icon {
    width: 32px;
    height: 32px;
  }
  .email__text {
    color: var(--primary);
  }
`;
export default BlueLabs;
